import React from 'react';
import PropTypes from 'prop-types';
import DataTableWithButton from "../../component/dataTable/DataTableWithButton";
import CheckOutProductColumn from "../../component/dataTable/columns/CheckOutProductColumn.json";
import CheckOutProductColumnWithButtons from "../../component/dataTable/columns/CheckOutProductColumnWithButtons.json";
import Translate from "../../../shared/language/Translate";
import {Button, ButtonGroup, Col, Row} from "reactstrap";
import GeneralUtils from "../../utils/GeneralUtils";
import BasketService from "../../service/BasketService";
import RestTableService from "../../service/RestTableService";
import {AvForm} from 'availity-reactstrap-validation';
import {PAGE_MODE} from "../../utils/Constants";
import Dialog from "../../component/dialog/Dialog";
import {toast} from "react-toastify";
import {getMemberTermsAndConditionsBodyHtml} from "./MemberLegalHtml";
import "../../../module/order/orderCheckoutActions.css";

const defaultOrder = {
    id: '', tableBssId: null
};

export class OrderCheckOut extends React.Component {

    constructor(props) {
        super(props);
        const yourOrderOpenDefault = props.initialYourOrderOpen !== undefined
            ? props.initialYourOrderOpen
            : true;
        this.state = {
            order: defaultOrder,
            expanded: false,
            totalPrice: 0,
            hasOrderBefore: false,
            totalTaxPrice: 0,
            subTotalPrice: 0,
            deliveryPrice: 0,
            calculatedServiceCharge: 0,
            manualDiscount:null,
            id: null,
            checkOutItemList: [],
            tables: [],
            pageMode: PAGE_MODE.CREATE,
            checkoutAttentionActive: false,
            yourOrderPanelOpen: yourOrderOpenDefault,
            displayDialog: false
        };
        this.onClick = this.onClick.bind(this);
        this.basketService = new BasketService();
        this.restTableService = new RestTableService();
        this._checkoutAttentionTimer = null;
        this._checkoutScheduleTimer = null;
        /** Set true only by addItem / add / addItemSetMenu so wave never runs on initial page basket sync */
        this._checkoutWaveFromUserAction = false;
    }

    componentWillUnmount() {
        if (this._checkoutAttentionTimer) {
            clearTimeout(this._checkoutAttentionTimer);
            this._checkoutAttentionTimer = null;
        }
        if (this._checkoutScheduleTimer) {
            clearTimeout(this._checkoutScheduleTimer);
            this._checkoutScheduleTimer = null;
        }
    }

    /** Brief highlight on Checkout after user adds / increases basket quantity */
    startCheckoutAttention = () => {
        if (this._checkoutAttentionTimer) {
            clearTimeout(this._checkoutAttentionTimer);
            this._checkoutAttentionTimer = null;
        }
        if (this.state.pageMode !== PAGE_MODE.CREATE) {
            return;
        }
        this.setState({checkoutAttentionActive: true});
        this._checkoutAttentionTimer = setTimeout(() => {
            this.setState({checkoutAttentionActive: false});
            this._checkoutAttentionTimer = null;
        }, 3200);
    }

    /** After parent setData / async basket refresh — run pulse after DOM catches up */
    scheduleCheckoutAttention = () => {
        if (this._checkoutScheduleTimer) {
            clearTimeout(this._checkoutScheduleTimer);
        }
        this._checkoutScheduleTimer = setTimeout(() => {
            this._checkoutScheduleTimer = null;
            this.startCheckoutAttention();
        }, 50);
    }

    componentDidUpdate(prevProps, prevState) {
        // table selection is driven by tableBssId in URL or localStorage
    }

    componentDidMount = async () => {


        this.restTableService.findByMerchantBranchId(localStorage.getItem("merchantBranchId")).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({tables: response});
            }
        });

        if (window.location.href.includes("tableBssId")) {
            const tid = GeneralUtils.getParameterByName('tableBssId');
            if (!GeneralUtils.isNullOrEmpty(tid)) {
                localStorage.setItem("tableBssId", tid);
            }
            let order = this.state.order;
            order["tableBssId"] = tid || localStorage.getItem("tableBssId");
            this.setState({order: order});
        } else {
            if (!GeneralUtils.isNullOrEmpty(localStorage.getItem("tableBssId"))) {
                let order = this.state.order;
                order["tableBssId"] = localStorage.getItem("tableBssId");
                this.setState({order: order});
            }
        }


    }


    setPageMode = (pageMode) => {
        this.setState({
            pageMode: pageMode
        });
    }

    addItem = (item) => {
        item.merchantBranchId = localStorage.getItem("merchantBranchId");
        if (GeneralUtils.isNullOrEmpty(item.quantity)) {
            item.quantity = 1;
        }
        this.basketService.addItemToBasket(item).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this._checkoutWaveFromUserAction = true;
                this.setDataToState(response);
                this.getBasketInfo(response);
            }
        });

    }

    setData = (data) => {
        let orderTemp = this.state.order;
        this.setState({
            order: orderTemp
        });
        this.setDataToState(data);

    }

    getData = () => {
        return this.state;
    }


    setBranchSettings = (orderType, minimumDeliveryBasketPrice, isClosed, serviceChargeOptions) => {
        this.setState({
            orderType: orderType,
            minimumDeliveryBasketPrice: minimumDeliveryBasketPrice,
            serviceChargeOptions: serviceChargeOptions,
        });

    }

    _basketLineCount = (list) => (Array.isArray(list) ? list.length : 0);

    _basketQtySum = (list) => {
        if (!Array.isArray(list)) {
            return 0;
        }
        return list.reduce((sum, row) => sum + (Number(row.quantity) || 0), 0);
    };

    setDataToState = (data) => {
        const fromUserAction = this._checkoutWaveFromUserAction;
        this._checkoutWaveFromUserAction = false;

        const prevList = this.state.checkOutItemList;
        const nextList = data.basketDetailList;
        const grew =
            this._basketLineCount(nextList) > this._basketLineCount(prevList)
            || this._basketQtySum(nextList) > this._basketQtySum(prevList);

        localStorage.setItem(data.merchantBranchId, data.bssId);
        this.setState({
            checkOutItemList: data.basketDetailList,
            totalPrice: data.totalPrice,
            subTotalPrice: data.subTotalPrice,
            totalTaxPrice: data.totalTaxPrice,
            deliveryPrice: data.deliveryPrice,
            manualDiscount:data.manualDiscount,
            id: data.id,
            deliveryFeeString: data.deliveryFeeString,
            calculatedServiceCharge: data.calculatedServiceCharge,
            serviceChargeIndex: data.serviceCharge
        }, () => {
            if (grew && fromUserAction && this.state.pageMode === PAGE_MODE.CREATE) {
                this.scheduleCheckoutAttention();
            }
        });

    }

    addItemSetMenu = (item) => {
        item.merchantBranchId = localStorage.getItem("merchantBranchId");
        this.basketService.addSetMenuItemToBasket(item).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this._checkoutWaveFromUserAction = true;
                this.setDataToState(response);
                this.getBasketInfo(response);
            }
        });
    }

    addServiceChargeToBasket = (serviceCharge) => {
        this.basketService.addServiceChargeToBasket(localStorage.getItem("merchantBranchId"), serviceCharge).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setDataToState(response);
                this.props.createDojoTokenAgain();
            }
        });
    }

    onClick(event) {
        this.setState({expanded: !this.state.expanded});
        event.preventDefault();
    }

    add = (rowData) => {
        rowData.merchantBranchId = localStorage.getItem("merchantBranchId");
        this.basketService.addOneQuantityToItem(rowData).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this._checkoutWaveFromUserAction = true;
                this.setDataToState(response);
                this.getBasketInfo(response);
            }
        });


    }

    subtract = (rowData) => {
        rowData.merchantBranchId = localStorage.getItem("merchantBranchId");
        this.basketService.removeItemFromBasket(rowData).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setDataToState(response);
                this.getBasketInfo(response);
            }
        });

    }

    getBasketInfo = (basketResponse) => {
        if (this.props.getBasketInfo) {
            this.props.getBasketInfo(basketResponse);
        }
    }

    onDataSelect = (rowData) => {
        if (this.state.pageMode == PAGE_MODE.CREATE) {
            if (!GeneralUtils.isNullOrEmpty(rowData.code)) {
                this.basketService.getSetMenuItemDetails(rowData.id).then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.props.openItemDetails(response);
                    }
                });
            }
        }

    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let order = this.state.order;
        order[e.target.name] = value;
        if (e.target.name == 'tableBssId') {
            localStorage.setItem("tableBssId", value);
        }
        this.setState({order: order});
    }

    setChecked = (name, value) => {
        let order = this.state.order;
        order[name] = value;
        this.setState({order: order});
    }

    openAggrementDialog = (e) => {
        if (e) {
            e.preventDefault();
        }
        this.setState({displayDialog: true});
    }

    render() {
        const yourOrderOpen = this.state.yourOrderPanelOpen;
        return (<div>
            <AvForm>
                <section
                    className={`co-checkout-panel co-checkout-panel--collapsible${yourOrderOpen ? '' : ' co-checkout-panel--collapsed'}`}
                    aria-labelledby="co-checkout-your-order-heading"
                >
                    <h2 className="co-checkout-panel__head co-checkout-panel__head--toggle">
                        <button
                            type="button"
                            id="co-checkout-your-order-heading"
                            className="co-checkout-panel__toggle"
                            aria-expanded={yourOrderOpen}
                            aria-controls="co-checkout-your-order-body"
                            onClick={() => this.setState((prev) => ({ yourOrderPanelOpen: !prev.yourOrderPanelOpen }))}
                        >
                            <span className="co-checkout-panel__toggle-label">
                                <Translate contentKey="order.checkout.yourOrder">Your Order</Translate>
                            </span>
                            <i className="material-icons co-checkout-panel__chevron" aria-hidden="true">expand_more</i>
                        </button>
                    </h2>
                    <div id="co-checkout-your-order-body" className="co-checkout-panel__body" hidden={!yourOrderOpen}>
                    <DataTableWithButton data={this.state.checkOutItemList} subtract={this.subtract} add={this.add}
                                         className="checkout-order-table"
                                         ref={(elem) => this.refDataTable = elem}
                                         onDataSelect={this.onDataSelect}
                                         selectionMode='single'
                                         emptyMessage="Start your order"
                                         paginator={false}
                                         fields={this.state.pageMode == PAGE_MODE.CREATE ? CheckOutProductColumnWithButtons.fields : CheckOutProductColumn.fields}> </DataTableWithButton>
                    <p></p>

                    {this.renderServiceCharge()}
                    <p></p>

                    <Row className="checkout-summary-row checkout-summary-row--subtotal">

                        <Col style={{textAlign: "left"}}>
                            <span htmlFor="productItem">
                                &nbsp;&nbsp;Subtotal
                                {this.state.totalTaxPrice > 0 &&
                                    ` (incl. £${this.state.totalTaxPrice.toFixed(2)} VAT)`
                                }:
                            </span>
                        </Col>
                        <Col style={{textAlign: "right"}}>
                            £{this.state.subTotalPrice.toFixed(2)}
                        </Col>

                    </Row>
                    <p></p>

                    {this.state.pageMode != PAGE_MODE.CREATE &&  !GeneralUtils.isNullOrEmpty(this.state.manualDiscount) &&
                        <Row className="checkout-summary-row">

                            <Col style={{textAlign: "left"}}>
                                <span htmlFor="productItem">&nbsp;&nbsp;Discount:
                                </span>
                            </Col>
                            <Col style={{textAlign: "right"}}>
                                £{this.state.manualDiscount.toFixed(2)}
                            </Col>


                        </Row>}
                    {this.state.pageMode != PAGE_MODE.CREATE &&  !GeneralUtils.isNullOrEmpty(this.state.manualDiscount) &&

                        <p></p>
                    }


                    {this.state.pageMode != PAGE_MODE.CREATE && this.state.orderType == "Delivery" && this.state.deliveryPrice != null &&
                        <Row className="checkout-summary-row">

                            <Col style={{textAlign: "left"}}>
                                <span htmlFor="productItem">&nbsp;&nbsp;Delivery Fee:
                                </span>
                            </Col>
                            <Col style={{textAlign: "right"}}>
                                £{this.state.deliveryPrice.toFixed(2)}
                            </Col>


                        </Row>}
                    {this.state.pageMode != PAGE_MODE.CREATE && this.state.orderType == "Delivery" && this.state.deliveryPrice != null &&

                        <p></p>
                    }

                    {this.state.pageMode != PAGE_MODE.CREATE && this.state.calculatedServiceCharge != null &&
                        <Row className="checkout-summary-row">

                            <Col style={{textAlign: "left"}}>
                                <span htmlFor="productItem">&nbsp;&nbsp;Service Charge:
                                </span>
                            </Col>
                            <Col style={{textAlign: "right"}}>
                                £{this.state.calculatedServiceCharge.toFixed(2)}
                            </Col>


                        </Row>}
                    {this.state.pageMode != PAGE_MODE.CREATE && this.state.calculatedServiceCharge != null &&

                        <p></p>
                    }
                    <Row className="checkout-summary-row">
                        <Col style={{textAlign: "left"}}>
                            <label htmlFor="productItem">&nbsp;&nbsp;Total:
                            </label>
                        </Col>
                        <Col style={{textAlign: "right"}}>
                            <b> £{this.state.totalPrice.toFixed(2)}</b>

                        </Col>
                        <hr></hr>

                    </Row>
                    {this.getWarnings()}


                    {this.renderApprovement()}


                    <div className="checkout-cart-actions">
                        {this.state.pageMode == PAGE_MODE.CREATE &&
                            <div className="checkout-cart-actions-primary">
                            <div className="checkout-cta-ring-wrap">
                                <div className="checkout-cta-ring-inner">
                                    <Button color="primary"
                                            className="checkout-action-btn"
                                            disabled={this.state.checkOutItemList.length == 0}
                                            onClick={() => {

                                                var validations = this.props.checkDeliveryPostCodeIsValid();
                                                if (GeneralUtils.isNullOrEmpty(validations)) {
                                                    if (GeneralUtils.isAuthenticated()) {
                                                        window.location.href = "/approveOrder";
                                                    } else {
                                                        window.location.href = "/login?" + localStorage.getItem(localStorage.getItem("merchantBranchId"));
                                                    }
                                                }
                                                else {
                                                    return toast.warn(validations);
                                                }

                                            }}>
                                        <Translate contentKey="entity.action.add">Checkout</Translate>
                                    </Button>
                                </div>
                                {this.state.checkoutAttentionActive &&
                                    <svg
                                        className="checkout-border-wave-svg"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 400 52"
                                        preserveAspectRatio="none"
                                        aria-hidden="true"
                                        focusable="false">
                                        <defs>
                                            <linearGradient id="dispatchioCheckoutWaveGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                                                <stop offset="0%" stopColor="#1d4ed8"/>
                                                <stop offset="40%" stopColor="#93c5fd"/>
                                                <stop offset="50%" stopColor="#ffffff"/>
                                                <stop offset="60%" stopColor="#93c5fd"/>
                                                <stop offset="100%" stopColor="#1d4ed8"/>
                                            </linearGradient>
                                        </defs>
                                        <rect
                                            className="checkout-border-wave-rect"
                                            x="2"
                                            y="2"
                                            width="396"
                                            height="48"
                                            rx="9"
                                            ry="9"
                                            fill="none"
                                            stroke="url(#dispatchioCheckoutWaveGrad)"
                                            strokeWidth="2.5"
                                            strokeLinecap="round"
                                            strokeDasharray="55 945"
                                            pathLength="1000"
                                        />
                                    </svg>
                                }
                            </div>
                            </div>
                        }

                        {this.state.pageMode == PAGE_MODE.CREATE && GeneralUtils.isMobile() &&
                            <div className="checkout-cart-actions-secondary">
                                <Button color="outline-primary"
                                        className="checkout-action-btn"
                                        disabled={false}
                                        onClick={() => {
                                            this.props.hidecart();
                                        }}>
                                    <Translate contentKey="entity.action.add">Continue Shopping</Translate>
                                </Button>
                            </div>
                        }
                    </div>

                    </div>
                </section>
            </AvForm>
        </div>);
    }

    getTermsAndConditionText() {
        let form = [];
        form.push(<div dangerouslySetInnerHTML={{
            __html: getMemberTermsAndConditionsBodyHtml()
        }}/>);
        return form;
    }

    renderApprovement() {
        let form = [];
        if (this.state.pageMode == PAGE_MODE.CREATE && this.state.hasOrderBefore == false) {
            form.push(
                <React.Fragment key="checkout-terms">
                    <div className="checkout-terms-agreement">
                        <label htmlFor="approveAggrement">
                            {(() => {
                                const merchant = GeneralUtils.getMemberLegalEntityName();
                                const payee = GeneralUtils.isNullOrEmpty(merchant)
                                    ? 'us'
                                    : merchant;
                                return (
                                    <>
                                        By placing an order you agree to pay {payee} and accept our{' '}
                                        <a
                                            id="myLink"
                                            href="javascript:void(0);"
                                            onClick={this.openAggrementDialog}
                                        >
                                            Terms &amp; Conditions
                                        </a>
                                    </>
                                );
                            })()}
                        </label>
                    </div>

                    <Dialog
                            className="checkout-terms-dialog"
                            header="Terms & Conditions"
                            visible={this.state.displayDialog}
                            style={GeneralUtils.getDialogStyleForDialog()}
                            onHide={() => this.setState({displayDialog: false})}
                    >


                        <p className="m-0">
                            {this.getTermsAndConditionText()}

                        </p>

                        <Button color="outline-primary" style={{marginRight: '5px', height: '30px'}}
                                onClick={() => {
                                    this.setState({displayDialog: false})

                                }}>
                            <Translate contentKey="entity.action.cancel">Close</Translate>
                        </Button>

                    </Dialog>
                </React.Fragment>
            );

        }
        return form;
    }

    renderServiceCharge() {

        let form = [];

        if (this.state.pageMode != PAGE_MODE.CREATE && (this.state.serviceChargeOptions == "ACTIVE" || this.state.serviceChargeOptions == "ENFORCED")) {
            form.push(
                <Row>
                    <Col>

                        <label htmlFor="productItem">&nbsp;&nbsp;Add a service charge?</label>
                        {this.state.serviceChargeOptions == "ACTIVE" &&
                            <label htmlFor="approveAggrement">&nbsp;&nbsp;<a
                                id="notThisTime"
                                href="javascript:void(0);" onClick={() => {
                                this.setState({serviceChargeIndex: "0%"});
                                this.addServiceChargeToBasket("0%")
                            }}>Not this
                                time</a></label>
                        }
                        <ButtonGroup style={{display: "flex", zIndex: 0}}>
                            <Button
                                color="primary"
                                outline
                                onClick={() => {
                                    this.setState({serviceChargeIndex: "5%"});
                                    this.addServiceChargeToBasket("5%")
                                }}
                                active={this.state.serviceChargeIndex === "5%"}
                            >
                                5%
                            </Button>

                            <Button
                                color="primary"
                                outline
                                onClick={() => {
                                    this.setState({serviceChargeIndex: "10%"});
                                    this.addServiceChargeToBasket("10%")
                                }}
                                active={this.state.serviceChargeIndex === "10%"}
                            >
                                10%
                            </Button>
                            <Button
                                color="primary"
                                outline
                                onClick={() => {
                                    this.setState({serviceChargeIndex: "20%"});
                                    this.addServiceChargeToBasket("20%")
                                }}
                                active={this.state.serviceChargeIndex === "20%"}
                            >
                                20%
                            </Button>


                        </ButtonGroup>

                    </Col>


                </Row>
            );
        }
        if (this.state.pageMode != PAGE_MODE.CREATE && (this.state.serviceChargeOptions == "ACTIVE" || this.state.serviceChargeOptions == "ENFORCED")) {
            form.push(<hr></hr>);
        }

        return form;
    }

    getWarnings() {
        const isCheckout = this.state.pageMode !== PAGE_MODE.CREATE;
        const isDelivery = this.state.orderType === "Delivery";
        if (!isCheckout || !isDelivery) {
            return null;
        }
        const hasFeeNote = !GeneralUtils.isNullOrEmpty(this.state.deliveryFeeString);
        const hasMinBasket = !GeneralUtils.isNullOrEmpty(this.state.minimumDeliveryBasketPrice);
        if (!hasFeeNote && !hasMinBasket) {
            return null;
        }
        return (
            <div className="checkout-order-notes">
                {hasFeeNote && (
                    <Row className="checkout-order-note-row checkout-summary-row">
                        <Col xs="12" style={{textAlign: "left"}}>
                            <label htmlFor="productItem">
                                &nbsp;&nbsp;{this.state.deliveryFeeString}
                            </label>
                        </Col>
                    </Row>
                )}
                {hasMinBasket && (
                    <Row className="checkout-order-note-row checkout-summary-row">
                        <Col style={{textAlign: "left"}}>
                            <label htmlFor="productItem">
                                &nbsp;&nbsp;Minimum Basket Total:
                            </label>
                        </Col>
                        <Col style={{textAlign: "right"}}>
                            <b>£{this.state.minimumDeliveryBasketPrice.toFixed(2)}</b>
                        </Col>
                    </Row>
                )}
            </div>
        );
    }
}

OrderCheckOut.propTypes = {
    /** Store/cart: true (open). Approve/confirm checkout: false (collapsed until user expands) */
    initialYourOrderOpen: PropTypes.bool
};
